import { values } from './enums'

const _enum = {
  Unbegun: 0,
  Incomplete: 1,
  Sent: 2,
  Rejected: 3,
  Accepted: 4,
  SignPending: 5
}

export const ReportSubmissionGroupState = {
  enumName: 'ReportSubmissionGroupState',
  enum: _enum,
  values: values(_enum)
}



// WEBPACK FOOTER //
// ./src/enums/ReportSubmissionGroupState.js